<template>

    <div>
        <div class="nav-bar">
            <div id="tabbar-cadastros" style="line-height: 18px;"  @click="navigate($event, 'Cadastros')" 

                v-bind:class="{ 'nav-bar-item': true, 
                    'nav-bar-item-active': ((tabbar=='cadastros')||(!tabbar)) }">
                <i class="far fa-address-card fa-lg nav-awesome"></i><br>
                Cadastros
            </div>
            <div id="tabbar-financeiro" style="line-height: 18px;"  @click="navigate($event, 'Financeiro')" 
                v-bind:class="{ 'nav-bar-item': true, 
                    'nav-bar-item-active': (tabbar=='financeiro') }">

                <i class="fas fa-hand-holding-usd fa-lg nav-awesome"></i><br>
                Financeiro
            </div>

            <div id="tabbar-lembretes" style="line-height: 18px;" @click="navigate($event, 'Lembretes')" 
                v-bind:class="{ 'nav-bar-item': true, 
                    'nav-bar-item-active': (tabbar=='lembretes') }">
                <i class="far fa-clock fa-lg nav-awesome" ></i><br>
                Lembretes
            </div>

            <div class="nav-bar-item-active-bg" id="nav-bar-item-active-bg"></div>
        </div>
    </div>        


</template>

<script>


export default {
    name: 'TabPanel',

    data(){
        return {
            tabbar : ''
        }
    },

    created(){
        this.tabbar = this.getTabbar();
    },

    mounted(){ 

        this.tabbar = this.getTabbar();

        if(this.tabbar){
            this.navigateTarget(document.getElementsByClassName('nav-bar-item-active')[0], false);
        } else {
            this.navigateTarget(document.getElementsByClassName('nav-bar-item-active')[0], true);
        }

        this.$emit('navigate', this.tabbar);

    },

    methods : {
        

        getTabbar(){
            var path = this.$router.currentRoute.path.toLowerCase().slice(1).split('/');
            return path[0];
        },

        navigate(e, componenteExibir){ 

            if(this.$router.currentRoute.path.toLowerCase()!=`/${componenteExibir}`.toLowerCase()) {


                if(e.target.tagName=='I'){
                    var path = e.path || (e.composedPath && e.composedPath());

                    this.navigateTarget(path[1], true);
                } else {
                    this.navigateTarget(e.target, true);
                }

                this.$emit('navigate', componenteExibir);

                var componenteExibirLocal = componenteExibir.toLowerCase();
                
                this.$router.push(`/${componenteExibirLocal}`);

            }

        }, 
        
        navigateTarget(target, animated){

            var elem = document.getElementById('nav-bar-item-active-bg');
            

            if(animated){
                elem.classList.add('nav-bar-item-active-bg-transtion');
            } else {
                elem.classList.remove('nav-bar-item-active-bg-transtion');
            }


            elem.style.width = target.offsetWidth + 'px';
            elem.style.transform = 'translateX(' + target.offsetLeft + 'px)';

            document.querySelectorAll('.nav-bar-item').forEach(el => {
                el.classList.remove('nav-bar-item-active');
            });

            target.classList.add('nav-bar-item-active');
            elem.style.left = 'unset';


        }
    }
    
    
}
</script>


<style scoped>

</style>